import React from "react";

/**
 * Encabezado de sección compartido por los paneles de la ficha de orden:
 * título + línea hairline a todo el ancho, sin tarjeta ni fondo propio.
 */
export const Section = ({ title, action, children, testId }) => (
  <section data-testid={testId}>
    <div className="flex items-center justify-between border-b border-line pb-2">
      <h2 className="text-[13px] font-semibold text-ink">{title}</h2>
      {action}
    </div>
    <div className="pt-3">{children}</div>
  </section>
);
